import ActionReport from './ActionReport.vue'

const activismCenterComponents = [ActionReport]

export default activismCenterComponents
